import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'semantic-ui-react';

import Button from '../../../../components/Button';
import InputBox from '../../../../components/InputBox';
import Dropdown from '../../../../components/Dropdown/Dropdown';
import Spinner from '../../../../components/Spinner';

import './styles.scss';

const dropdownData = [
    {
        id: 5,
        name: `This position has been closed via ${process.env.REACT_APP_PLATFORM}.`   
    },
    {
        id: 6,
        name: 'This position has been closed via other channel.'
    },
    {
        id: 2,
        name: 'This position has gone on hold.'
    },
    {
        id: 3,
        name: 'I have received enough responses for this position.' 
    },
    {
        id: 7,
        name:  'Not received enough applicants.'
    },
    {
        id: 8,
        name: 'Not received enough quality applicants',
    }
]

const BulkUnpublishModal = (props) => {
    const [modalData, setModalData] = useState(props.jobsData);
    const [error, setError] = useState(null);

    const handleSubmit = () => {
        let isValid = true;

        modalData.map(item => {
            if (!item.reasonId) {
                isValid = false;
            }
        });

        if (!isValid) {
            setError('Please select reason for all the selected jobs.');
            return;
        }

        props.onBulkUnpublish(modalData);
    }

    const unpublishRadioChange = (event) => {
        const reasonId = event.target.value;
        const reason = dropdownData.filter(item => item.id == parseInt(reasonId));

        if (!reason || reason.length == 0) {
            return;
        }

        setModalData(prevArr => {
            return prevArr.map(item => {
                return {
                    ...item,
                    reasonId: parseInt(reasonId),
                    reason: reason[0].name
                }
            });
        });

        setError(null);
    };

    const handleDropdownChange = (reasonId, jobId) => {
        if (!reasonId)
            return;

        setModalData(prevArr => {
            const existingIndex = prevArr.findIndex(item => item.id == jobId);
            const reason = dropdownData.filter(item => item.id == parseInt(reasonId));

            const newArr = [ ...prevArr ];
            newArr[existingIndex] = {
                ...prevArr[existingIndex],
                reasonId: parseInt(reasonId),
                reason: reason && reason.length > 0 ? reason[0].name : null  
            };

            return newArr; 
        })
    }

    return (
        <Modal
            className='bulk-unpublish-modal'
            open={props.openModal}
            onClose={props.onCloseModal}
            closeIcon={true}
        >

            <Modal.Header className='bulk-unpublish-header'>
                Bulk Unpublish
            </Modal.Header>

            <div className='modal-sub-header'>You are about to unpublish {props.jobsData.length} jobs</div>
            <div className='modal-error'>{error}</div>

            <Modal.Content className='bulk-unpublish-content'>
                <div className='reasons__container'>
                    <div className='reasons__container--common'>
                        <div>Please choose a reason for unpublishing these jobs</div>
                        <div className='radio-group'>
                            {dropdownData.map(item => {
                                return (
                                    <div className='radio-group-row' key={item.id}>
                                        <InputBox type='radio' name="unpublish-radio" value={item.id} onChange={unpublishRadioChange} checked={item.reasonId}/>
                                        {item.name}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className='reasons__container--single'>
                        <div className='text-heading'>OR select job-wise reasons: </div>
                        {modalData.map(item => {
                            return (
                                <div className='job__row'>
                                    <span>{item.title}</span>
                                    <div className='dropdown'>
                                        <Dropdown 
                                            data={[
                                                {
                                                    id: 0,
                                                    name: 'Select reason',
                                                    disabled: true,
                                                    selected: true
                                                },
                                                ...dropdownData,
                                            ]}
                                            defaultValue={item.reasonId}
                                            dropdownChange={(event) => {
                                                handleDropdownChange(event.target.value, item.id)
                                            }}
                                        />
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </Modal.Content>

            <Modal.Actions>
                {props.isLoading ? (
                    <Spinner />
                ) : (
                    <>
                        <Button skin='light' text='Close' clickButton={props.onCloseModal} />
                        <Button skin='dark' text='Submit' clickButton={handleSubmit} />
                    </>
                )}
            </Modal.Actions>
        </Modal>
    );
};

BulkUnpublishModal.propTypes = {
    openModal: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    onBulkUnpublish: PropTypes.func.isRequired,
    jobsData: PropTypes.object.isRequired,
    selectedJobs: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default BulkUnpublishModal;
